import React, { useEffect, useState } from 'react';
import { Layout } from 'antd';

import MedicardChatBot from './components/medicardChatBot';
import getGenesysConfig from './genesys.config';
import './cx-theme-medicard.css';



const WebChat = () => {
  const [customPlugin, setCustomPlugin] = useState(null);

  useEffect(() => {
    // //Load Genesys Webchat Plugin
    const script = document.createElement("script");
    script.src = "https://apps.mypurecloud.jp/widgets/9.0/cxbus.min.js";
    script.onload = () => {
      window.CXBus.configure({
        debug: false,
        pluginsPath: 'https://apps.mypurecloud.jp/widgets/9.0/plugins/'
      }); 
      window.CXBus.loadPlugin('widgets-core');  
      window._genesys = getGenesysConfig();
      var customPluginLoad = window.CXBus && window.CXBus.registerPlugin('Custom');
      setCustomPlugin(customPluginLoad)
    }
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <Layout>
      { 
        customPlugin && 
        <MedicardChatBot customPlugin={customPlugin} />
      }
      
    </Layout>
  )
}

export default WebChat;
